import React from 'react';
import { Box, Copy, Image } from '@honda-canada/design-system-react';
import themeStyles from '../styles/Header.styles';

const BrandsContainer = themeStyles.apply(Box, 'BrandsContainer');
const BrandWrapper = themeStyles.apply(Box, 'BrandWrapper');
const BrandImage = themeStyles.apply(Image, 'BrandImage');
const EmptyImagePlaceholder = themeStyles.apply(Box, 'EmptyImagePlaceholder');
const BrandName = themeStyles.apply(Copy, 'BrandName');

const SubNavWithImage = ({ brands = [] }) => {
  if (!brands || !brands.length) return null;

  return (
    <BrandsContainer data-testid="header-mobile-brands-subnav">
      {brands.map((brand, i) => {
        const { ctaLink = {}, image = {} } = brand;
        const { href } = ctaLink;
        const { src, alt } = image;

        return (
          <BrandWrapper as="a" href={href} key={alt + i} data-testid="brands-subnav-brand-wrapper">
            {src ? (
              <BrandImage src={src} alt={alt} data-testid="brands-subnav-brand-logo" />
            ) : (
              <EmptyImagePlaceholder data-testid="brands-subnav-brand-logo" />
            )}
            <BrandName data-testid="brands-subnav-brand-name" size="small">
              {brand.itemName}
            </BrandName>
          </BrandWrapper>
        );
      })}
    </BrandsContainer>
  );
};

export default SubNavWithImage;
